import { render, staticRenderFns } from "./eidteFolderCompoment.vue?vue&type=template&id=5bb8cf12&scoped=true&"
import script from "./eidteFolderCompoment.vue?vue&type=script&lang=js&"
export * from "./eidteFolderCompoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8cf12",
  null
  
)

export default component.exports